import React from 'react';

const RequirementsComponent = () => {
  return (
    <div className="requirements-container">
      <h2 className="requirements-title">Requisitos</h2>
      <div className="requirement-item">
        <h2 className="requirement-title">1. Corresponding Author</h2>
        <p className="requirement-text">La persona que se comunique con la editorial tiene que tener un vínculo jurídico con la Universidad de Oviedo.</p>
      </div>
      <div className="requirement-item">
        <h2 className="requirement-title">2. Correo @uniovi.es</h2>
        <p className="requirement-text">El corresponding author debe usar su correo institucional.</p>
      </div>
      <div className="requirement-item">
        <h2 className="requirement-title">3. Depósito en RUO</h2>
        <p className="requirement-text">La versión final deberá ser depositada en el repositorio institucional.</p>
      </div>
    </div>
  );
};

export default RequirementsComponent;


